// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../../../../shared/src/StringUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var FormalityCompat = require("re-formality/src/FormalityCompat.bs.js");
var CommonTypes_Email = require("../../../../shared/src/types/CommonTypes_Email.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var CommonTypes_User_Id = require("../../../../shared/src/types/CommonTypes_User_Id.bs.js");
var WebStore_Types_Error = require("../../store/WebStore_Types_Error.bs.js");
var CommonTypes_User_Name = require("../../../../shared/src/types/CommonTypes_User_Name.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var WebGraphql_CurrentUser = require("../../graphql/WebGraphql_CurrentUser.bs.js");
var WebTypes_BusinessAdmin = require("../../types/WebTypes_BusinessAdmin.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var CommonTypes_PhoneNumber = require("../../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var WebComponents_SettingsModal = require("../../components/settings/WebComponents_SettingsModal.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_SettingsHeader = require("../../components/settings/WebComponents_SettingsHeader.bs.js");
var WebComponents_SettingsListRow = require("../../components/settings/WebComponents_SettingsListRow.bs.js");
var FormalityCompat__PublicHelpers = require("re-formality/src/FormalityCompat__PublicHelpers.bs.js");
var WebComponents_SettingsTabHeader = require("../../components/settings/WebComponents_SettingsTabHeader.bs.js");
var FormalityCompat__FormAsyncOnChange = require("re-formality/src/FormalityCompat__FormAsyncOnChange.bs.js");
var WebComponents_SettingsFormActionButtons = require("../../components/settings/WebComponents_SettingsFormActionButtons.bs.js");

function initialState(newBusinessAdminInfo, emailIsAvailable, phoneNumberIsAvailable) {
  return Relude_Option.getOrElse({
              firstName: "",
              lastName: "",
              email: "",
              phoneNumber: "",
              originalEmail: undefined,
              originalPhoneNumber: undefined,
              emailIsAvailable: emailIsAvailable,
              phoneNumberIsAvailable: phoneNumberIsAvailable
            }, Relude_Option.map((function (param) {
                    var phoneNumber = param.phoneNumber;
                    var email = param.email;
                    return {
                            firstName: Curry._1(CommonTypes_User_Name.FirstName.toString, param.firstName),
                            lastName: Curry._1(CommonTypes_User_Name.LastName.toString, param.lastName),
                            email: Curry._1(CommonTypes_Email.toString, email),
                            phoneNumber: CommonTypes_PhoneNumber.toString(phoneNumber),
                            originalEmail: Curry._1(CommonTypes_Email.toString, email),
                            originalPhoneNumber: CommonTypes_PhoneNumber.toString(phoneNumber),
                            emailIsAvailable: emailIsAvailable,
                            phoneNumberIsAvailable: phoneNumberIsAvailable
                          };
                  }), newBusinessAdminInfo));
}

var debounceInterval = FormalityCompat.Async.debounceInterval;

function get(param) {
  return param.firstName;
}

function update(setState, state, firstName) {
  return Curry._2(setState, /* FirstName */0, {
              firstName: firstName,
              lastName: state.lastName,
              email: state.email,
              phoneNumber: state.phoneNumber,
              originalEmail: state.originalEmail,
              originalPhoneNumber: state.originalPhoneNumber,
              emailIsAvailable: state.emailIsAvailable,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable
            });
}

function validator_validate(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Must have first name.", param);
              }), param);
}

var validator = {
  field: /* FirstName */0,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate,
  validateAsync: undefined
};

var FirstNameField = {
  get: get,
  update: update,
  validator: validator
};

function get$1(param) {
  return param.lastName;
}

function update$1(setState, state, lastName) {
  return Curry._2(setState, /* LastName */1, {
              firstName: state.firstName,
              lastName: lastName,
              email: state.email,
              phoneNumber: state.phoneNumber,
              originalEmail: state.originalEmail,
              originalPhoneNumber: state.originalPhoneNumber,
              emailIsAvailable: state.emailIsAvailable,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable
            });
}

function validator_validate$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$1, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Must have last name.", param);
              }), param);
}

var validator$1 = {
  field: /* LastName */1,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$1,
  validateAsync: undefined
};

var LastNameField = {
  get: get$1,
  update: update$1,
  validator: validator$1
};

function get$2(param) {
  return param.email;
}

function update$2(setState, state, email) {
  return Curry._2(setState, /* Email */2, {
              firstName: state.firstName,
              lastName: state.lastName,
              email: email,
              phoneNumber: state.phoneNumber,
              originalEmail: state.originalEmail,
              originalPhoneNumber: state.originalPhoneNumber,
              emailIsAvailable: state.emailIsAvailable,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable
            });
}

var invalidEmailMessage = "Enter a valid email address.";

var emailTakenMessage = "That email is already taken";

var getNewAdminEmailIsAvailable = Reselect.createSelector3(undefined, (function (param) {
        return param.email;
      }), (function (param) {
        return param.originalEmail;
      }), (function (param) {
        return param.emailIsAvailable;
      }), (function (email, originalEmail, emailIsAvailable) {
        if (Relude_Option.fold(false, (function (param) {
                  return Relude_String.eq(email, param);
                }), originalEmail)) {
          return Relude_IO.pure(Relude_Result.ok(/* Valid */0));
        } else {
          return Relude_Option.fold(Relude_IO.pure(Relude_Result.error(invalidEmailMessage)), (function (param) {
                        return Relude_Globals.$great$great(emailIsAvailable, (function (param) {
                                      return Relude_IO.map((function (isEmailAvailable) {
                                                    if (isEmailAvailable) {
                                                      return Relude_Result.ok(/* Valid */0);
                                                    } else {
                                                      return Relude_Result.error(emailTakenMessage);
                                                    }
                                                  }), param);
                                    }), param);
                      }), CommonTypes_Email.fromString(email));
        }
      }));

function validator_validate$2(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$2, CommonTypes_Email.fromString, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption(invalidEmailMessage, param);
              }), param);
}

var validator_validateAsync = [
  (function (param) {
      return Relude_Globals.$great$great(getNewAdminEmailIsAvailable, Relude_Js_Promise.fromIO, param);
    }),
  (function (prev, next) {
      return Relude_String.eq(get$2(prev), get$2(next));
    })
];

var validator$2 = {
  field: /* Email */2,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$2,
  validateAsync: validator_validateAsync
};

var EmailField = {
  get: get$2,
  update: update$2,
  invalidEmailMessage: invalidEmailMessage,
  emailTakenMessage: emailTakenMessage,
  getNewAdminEmailIsAvailable: getNewAdminEmailIsAvailable,
  validator: validator$2
};

function get$3(param) {
  return param.phoneNumber;
}

function update$3(setState, state, phoneNumber) {
  return Curry._2(setState, /* PhoneNumber */3, {
              firstName: state.firstName,
              lastName: state.lastName,
              email: state.email,
              phoneNumber: phoneNumber,
              originalEmail: state.originalEmail,
              originalPhoneNumber: state.originalPhoneNumber,
              emailIsAvailable: state.emailIsAvailable,
              phoneNumberIsAvailable: state.phoneNumberIsAvailable
            });
}

var invalidPhoneMessage = "Enter a valid phone number";

var phoneNumberTakenMessage = "That phone number is already taken";

var getNewAdminPhoneNumberIsAvailable = Reselect.createSelector3(undefined, (function (param) {
        return param.phoneNumber;
      }), (function (param) {
        return param.originalPhoneNumber;
      }), (function (param) {
        return param.phoneNumberIsAvailable;
      }), (function (phoneNumber, originalPhoneNumber, phoneNumberIsAvailable) {
        if (Relude_Option.fold(false, (function (param) {
                  return Relude_String.eq(phoneNumber, param);
                }), originalPhoneNumber)) {
          return Relude_IO.pure(Relude_Result.ok(/* Valid */0));
        } else {
          return Relude_Option.fold(Relude_IO.pure(Relude_Result.error(invalidPhoneMessage)), (function (param) {
                        return Relude_Globals.$great$great(phoneNumberIsAvailable, (function (param) {
                                      return Relude_IO.map((function (isPhoneNumberAvailable) {
                                                    if (isPhoneNumberAvailable) {
                                                      return Relude_Result.ok(/* Valid */0);
                                                    } else {
                                                      return Relude_Result.error(phoneNumberTakenMessage);
                                                    }
                                                  }), param);
                                    }), param);
                      }), CommonTypes_LongPhoneNumber.fromString(phoneNumber));
        }
      }));

function validator_validate$3(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$3, CommonTypes_LongPhoneNumber.fromString, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption(invalidPhoneMessage, param);
              }), param);
}

var validator_validateAsync$1 = [
  (function (param) {
      return Relude_Globals.$great$great(getNewAdminPhoneNumberIsAvailable, Relude_Js_Promise.fromIO, param);
    }),
  (function (prev, next) {
      return Relude_String.eq(get$3(prev), get$3(next));
    })
];

var validator$3 = {
  field: /* PhoneNumber */3,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$3,
  validateAsync: validator_validateAsync$1
};

var PhoneNumberField = {
  get: get$3,
  update: update$3,
  invalidPhoneMessage: invalidPhoneMessage,
  phoneNumberTakenMessage: phoneNumberTakenMessage,
  getNewAdminPhoneNumberIsAvailable: getNewAdminPhoneNumberIsAvailable,
  validator: validator$3
};

var validators_1 = {
  hd: validator$1,
  tl: {
    hd: validator$2,
    tl: {
      hd: validator$3,
      tl: /* [] */0
    }
  }
};

var validators = {
  hd: validator,
  tl: validators_1
};

var Form = {
  initialState: initialState,
  debounceInterval: debounceInterval,
  FirstNameField: FirstNameField,
  LastNameField: LastNameField,
  EmailField: EmailField,
  PhoneNumberField: PhoneNumberField,
  validators: validators
};

var FormContainer = FormalityCompat__FormAsyncOnChange.Make({
      debounceInterval: debounceInterval,
      validators: validators
    });

function WebContainers_BusinessDashboard_Settings_Admins$AddEditAdmin(Props) {
  var emailIsAvailable = Props.emailIsAvailable;
  var headerText = Props.headerText;
  var newBusinessAdminInfo = Props.newBusinessAdminInfo;
  var onCancel = Props.onCancel;
  var phoneNumberIsAvailable = Props.phoneNumberIsAvailable;
  var saveButtonBusyText = Props.saveButtonBusyText;
  var saveButtonText = Props.saveButtonText;
  var saveEditingUser = Props.saveEditingUser;
  var match = Curry._2(FormContainer.useForm, initialState(newBusinessAdminInfo, emailIsAvailable, phoneNumberIsAvailable), (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          var partial_arg = initialState(newBusinessAdminInfo, emailIsAvailable, phoneNumberIsAvailable);
          var partial_arg$1 = function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          };
          var partial_arg$2 = function (param) {
            return Relude_Globals.$great$great(partial_arg$1, Relude_Option.pure, param);
          };
          var partial_arg$3 = function (param) {
            return Relude_Globals.$great$great(partial_arg$2, notifyOnSuccess, param);
          };
          var partial_arg$4 = Curry._1(Relude_IO.mapError, (function (param) {
                  return Relude_Globals.$$const(/* ErrorUpdatingOrAddingAdmin */0, param);
                }));
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold(notifyOnFailure, partial_arg$3, param);
                      }), Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(saveEditingUser, partial_arg$4, param);
                          }), Relude_Option.fold(Relude_IO.$$throw(/* ValidationError */1), Relude_IO.pure, Curry._2(Relude_Option.mapTuple4, (function (phoneNumber, email, firstName, lastName) {
                                    return WebTypes_BusinessAdmin.New.make(firstName, lastName, phoneNumber, email);
                                  }), [
                                  CommonTypes_PhoneNumber.fromString(param.phoneNumber),
                                  CommonTypes_Email.fromString(param.email),
                                  Curry._1(CommonTypes_User_Name.FirstName.fromString, param.firstName),
                                  Curry._1(CommonTypes_User_Name.LastName.fromString, param.lastName)
                                ]))));
        }));
  var submit = match.submit;
  var blur = match.blur;
  var change = match.change;
  var submitting = match.submitting;
  var result = match.result;
  var status = match.status;
  var state = match.state;
  var tmp;
  tmp = typeof status === "number" || !(status.TAG === /* SubmissionFailed */1 && !status._0) ? false : true;
  return React.createElement("form", {
              onSubmit: (function (param) {
                  return FormalityCompat__PublicHelpers.Dom.preventDefault(submit, param);
                })
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  children: null
                }, React.createElement(WebComponents_SettingsHeader.make, {
                      title: headerText
                    }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* FirstName */0))(undefined, undefined, undefined, undefined, submitting, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                  return Curry._1(blur, /* FirstName */0);
                                }), undefined, undefined, undefined, undefined, undefined, "firstNameInput", undefined, "First Name", undefined, undefined, undefined, undefined), {
                          TAG: /* Text */7,
                          _0: {
                            onChange: (function (param) {
                                return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                              return Relude_IO.map((function (param) {
                                                            return update(change, state, param);
                                                          }), param);
                                            }), param);
                              }),
                            value: state.firstName
                          }
                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* LastName */1))(undefined, undefined, undefined, undefined, submitting, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                  return Curry._1(blur, /* LastName */1);
                                }), undefined, undefined, undefined, undefined, undefined, "lastNameInput", undefined, "Last Name", undefined, undefined, undefined, undefined), {
                          TAG: /* Text */7,
                          _0: {
                            onChange: (function (param) {
                                return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                              return Relude_IO.map((function (param) {
                                                            return update$1(change, state, param);
                                                          }), param);
                                            }), param);
                              }),
                            value: state.lastName
                          }
                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* PhoneNumber */3))(undefined, undefined, undefined, undefined, submitting, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                  return Curry._1(blur, /* PhoneNumber */3);
                                }), undefined, undefined, undefined, undefined, undefined, "phoneNumberInput", undefined, "Phone Number", undefined, undefined, undefined, undefined), {
                          TAG: /* Text */7,
                          _0: {
                            onChange: (function (param) {
                                return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                              return Relude_IO.map((function (param) {
                                                            return update$3(change, state, param);
                                                          }), param);
                                            }), param);
                              }),
                            value: state.phoneNumber
                          }
                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* Email */2))(undefined, undefined, undefined, undefined, submitting, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                                  return Curry._1(blur, /* Email */2);
                                }), undefined, undefined, undefined, undefined, undefined, "emailInput", undefined, "Email", undefined, undefined, undefined, undefined), {
                          TAG: /* Email */3,
                          _0: {
                            onChange: (function (param) {
                                return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                              return Relude_IO.map((function (param) {
                                                            return update$2(change, state, param);
                                                          }), param);
                                            }), param);
                              }),
                            value: state.email
                          }
                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement(WebComponents_SettingsFormActionButtons.make, {
                      isSubmitting: submitting,
                      onCancel: onCancel,
                      showError: tmp,
                      submitButtonTitle: saveButtonText,
                      submitButtonBusyTitle: saveButtonBusyText
                    })));
}

var AddEditAdmin = {
  Form: Form,
  FormContainer: FormContainer,
  make: WebContainers_BusinessDashboard_Settings_Admins$AddEditAdmin
};

function WebContainers_BusinessDashboard_Settings_Admins$EditView(Props) {
  var editingUserId = Props.editingUserId;
  var users = Props.users;
  var onSave = Props.onSave;
  var onCancel = Props.onCancel;
  var emailIsAvailable = Props.emailIsAvailable;
  var phoneNumberIsAvailable = Props.phoneNumberIsAvailable;
  return React.createElement(WebContainers_BusinessDashboard_Settings_Admins$AddEditAdmin, {
              emailIsAvailable: emailIsAvailable,
              headerText: Relude_Option.isSome(editingUserId) ? "Edit Admin" : "Invite Admin",
              newBusinessAdminInfo: Relude_Option.map(WebTypes_BusinessAdmin.New.makeFromExisting, Curry._2(Relude_Option.flatMap, (function (userId) {
                          return Curry._2(Relude_Array.find, (function (param) {
                                        return Curry._2(WebTypes_BusinessAdmin.Id.eq, param.id, userId);
                                      }), users);
                        }), editingUserId)),
              onCancel: onCancel,
              phoneNumberIsAvailable: phoneNumberIsAvailable,
              saveButtonBusyText: Relude_Option.isSome(editingUserId) ? "Saving Admin" : "Sending Invite",
              saveButtonText: Relude_Option.isSome(editingUserId) ? "Save Admin" : "Send Invite",
              saveEditingUser: onSave
            });
}

var EditView = {
  make: WebContainers_BusinessDashboard_Settings_Admins$EditView
};

function WebContainers_BusinessDashboard_Settings_Admins$RemoveAdminModal(Props) {
  var firstName = Props.firstName;
  var id = Props.id;
  var isShowing = Props.isShowing;
  var removeBusinessAdmin = Props.removeBusinessAdmin;
  var setSettingsPageView = Props.setSettingsPageView;
  var match = ReactIO.useState(Relude_AsyncResult.completeOk);
  var loadingStatus = match[0];
  var disabled = Relude_AsyncResult.foldByValue(true, (function (param) {
          return Relude_Globals.$$const(false, param);
        }), (function (param) {
          return Relude_Globals.$$const(false, param);
        }), loadingStatus);
  var removeText = Relude_AsyncResult.foldByValue(true, (function (param) {
          return Relude_Globals.$$const(false, param);
        }), (function (param) {
          return Relude_Globals.$$const(false, param);
        }), loadingStatus) ? "REMOVING..." : "REMOVE ACCESS";
  if (isShowing) {
    return React.createElement(WebComponents_SettingsModal.make, {
                confirmButtonTitle: removeText,
                description: "Removing admin access will prevent a user from being able to see your dashboard, as well as remove the ability to post shifts. Are you sure you want to continue?",
                disabled: disabled,
                onConfirm: IOUtils.ioWithStatus(undefined, match[1], Curry._1(removeBusinessAdmin, id)),
                onCancel: Curry._1(setSettingsPageView, /* Viewing */0),
                showError: Relude_Option.isSome(Relude_AsyncResult.getError(loadingStatus)),
                title: "Remove " + (Curry._1(CommonTypes_User_Name.FirstName.toString, firstName) + "'s Admin Access?")
              });
  } else {
    return null;
  }
}

var RemoveAdminModal = {
  make: WebContainers_BusinessDashboard_Settings_Admins$RemoveAdminModal
};

function WebContainers_BusinessDashboard_Settings_Admins$AdminList(Props) {
  var layout = Props.layout;
  var removeBusinessAdmin = Props.removeBusinessAdmin;
  var removeButtonText = Props.removeButtonText;
  var removingUserId = Props.removingUserId;
  var setSettingsPageView = Props.setSettingsPageView;
  var param = Props.user;
  var users = Props.users;
  var userId = param.id;
  var businessOwnerUserId = param.business.businessOwnerUserId;
  return Curry._2(Relude_Array.map, (function (param) {
                var name = param.name;
                var firstName = name.firstName;
                var id = param.id;
                var secondaryText = Curry._1(CommonTypes_Email.toString, param.email) + (StringUtils.interpunct + CommonTypes_PhoneNumber.toString(param.phoneNumber));
                return React.createElement(React.Fragment, {
                            children: null,
                            key: Curry._1(WebTypes_BusinessAdmin.Id.toString, id)
                          }, React.createElement(WebComponents_SettingsListRow.make, {
                                firstName: firstName,
                                isRemovable: Curry._2(Relude_Int.notEq, Curry._1(WebTypes_BusinessAdmin.Id.toInt, id), Curry._1(CommonTypes_User_Id.toInt, userId)) && Curry._2(Relude_Int.notEq, Curry._1(WebTypes_BusinessAdmin.Id.toInt, id), Curry._1(CommonTypes_User_Id.toInt, businessOwnerUserId)),
                                lastName: name.lastName,
                                layout: layout,
                                onClickEdit: Curry._1(setSettingsPageView, {
                                      TAG: /* Editing */0,
                                      _0: id
                                    }),
                                onClickRemove: Curry._1(setSettingsPageView, {
                                      TAG: /* Removing */1,
                                      _0: id
                                    }),
                                primaryText: CommonTypes_User_Name.toString(name),
                                removeButtonText: removeButtonText,
                                secondaryText: secondaryText
                              }), React.createElement(WebContainers_BusinessDashboard_Settings_Admins$RemoveAdminModal, {
                                firstName: firstName,
                                id: id,
                                isShowing: removingUserId === Caml_option.some(id),
                                removeBusinessAdmin: removeBusinessAdmin,
                                setSettingsPageView: setSettingsPageView
                              }));
              }), users);
}

var AdminList = {
  make: WebContainers_BusinessDashboard_Settings_Admins$AdminList
};

function WebContainers_BusinessDashboard_Settings_Admins$ListView(Props) {
  var layout = Props.layout;
  var removeBusinessAdmin = Props.removeBusinessAdmin;
  var removingUserId = Props.removingUserId;
  var setSettingsPageView = Props.setSettingsPageView;
  var user = Props.user;
  var users = Props.users;
  return React.createElement(React.Fragment, undefined, React.createElement(WebComponents_SettingsTabHeader.make, {
                  addButtonClick: Curry._1(setSettingsPageView, /* Creating */1),
                  addButtonText: "Invite Admin",
                  description: "Add team members to your company's account, giving them access to post shifts, view upcoming and past shifts, manage shifts rosters and more.",
                  title: "Admins"
                }), React.createElement(WebContainers_BusinessDashboard_Settings_Admins$AdminList, {
                  layout: layout,
                  removeBusinessAdmin: removeBusinessAdmin,
                  removeButtonText: "Remove Access",
                  removingUserId: removingUserId,
                  setSettingsPageView: setSettingsPageView,
                  user: user,
                  users: users
                }));
}

var ListView = {
  make: WebContainers_BusinessDashboard_Settings_Admins$ListView
};

function WebContainers_BusinessDashboard_Settings_Admins$Presentation(Props) {
  var addBusinessAdmin = Props.addBusinessAdmin;
  var editBusinessAdmin = Props.editBusinessAdmin;
  var emailIsAvailable = Props.emailIsAvailable;
  var fetchSavedBusinessAdmins = Props.fetchSavedBusinessAdmins;
  var layout = Props.layout;
  var phoneNumberIsAvailable = Props.phoneNumberIsAvailable;
  var removeBusinessAdmin = Props.removeBusinessAdmin;
  var savedBusinessAdmins = Props.savedBusinessAdmins;
  var setSettingsPageView = Props.setSettingsPageView;
  var subPage = Props.subPage;
  var user = Props.user;
  ReactIO.useHandledIOOnMount(undefined)(fetchSavedBusinessAdmins);
  return Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.make, {}), (function (savedBusinessAdmins) {
                var tmp;
                if (typeof subPage === "number") {
                  tmp = subPage === /* Viewing */0 ? React.createElement(WebContainers_BusinessDashboard_Settings_Admins$ListView, {
                          layout: layout,
                          removeBusinessAdmin: removeBusinessAdmin,
                          removingUserId: undefined,
                          setSettingsPageView: setSettingsPageView,
                          user: user,
                          users: Curry._1(WebTypes_BusinessAdmin.$$Set.toArray, savedBusinessAdmins)
                        }) : React.createElement(WebContainers_BusinessDashboard_Settings_Admins$EditView, {
                          users: Curry._1(WebTypes_BusinessAdmin.$$Set.toArray, savedBusinessAdmins),
                          onSave: addBusinessAdmin,
                          onCancel: Curry._1(setSettingsPageView, /* Viewing */0),
                          emailIsAvailable: emailIsAvailable,
                          phoneNumberIsAvailable: phoneNumberIsAvailable
                        });
                } else if (subPage.TAG === /* Editing */0) {
                  var editingUserId = subPage._0;
                  tmp = React.createElement(WebContainers_BusinessDashboard_Settings_Admins$EditView, {
                        editingUserId: editingUserId,
                        users: Curry._1(WebTypes_BusinessAdmin.$$Set.toArray, savedBusinessAdmins),
                        onSave: (function (param) {
                            return Curry._1(editBusinessAdmin, WebTypes_BusinessAdmin.make(param.email, param.firstName, editingUserId, param.lastName, param.phoneNumber));
                          }),
                        onCancel: Curry._1(setSettingsPageView, /* Viewing */0),
                        emailIsAvailable: emailIsAvailable,
                        phoneNumberIsAvailable: phoneNumberIsAvailable
                      });
                } else {
                  tmp = React.createElement(WebContainers_BusinessDashboard_Settings_Admins$ListView, {
                        layout: layout,
                        removeBusinessAdmin: removeBusinessAdmin,
                        removingUserId: Caml_option.some(subPage._0),
                        setSettingsPageView: setSettingsPageView,
                        user: user,
                        users: Curry._1(WebTypes_BusinessAdmin.$$Set.toArray, savedBusinessAdmins)
                      });
                }
                return React.createElement(React.Fragment, undefined, tmp);
              }), (function (error) {
                return React.createElement(ReactUtils.S.make, {
                            children: WebStore_Types_Error.dispatchErrorToString(error)
                          });
              }), savedBusinessAdmins);
}

var Presentation = {
  make: WebContainers_BusinessDashboard_Settings_Admins$Presentation
};

var mapStateToProps = Reselect.createSelector3(undefined, WebStore_Selectors.getAuthorizedClient, (function (param) {
        return param.layout;
      }), (function (param) {
        return param.savedBusinessAdmins;
      }), (function (authorizedClient, layout, savedBusinessAdmins) {
        return {
                authorizedClient: authorizedClient,
                layout: layout,
                savedBusinessAdmins: savedBusinessAdmins
              };
      }));

function mapDispatchToProps(dispatch, param) {
  var authorizedClient = param.authorizedClient;
  return {
          addBusinessAdmin: (function (newAdmin) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.addBusinessAdmin(newAdmin)));
            }),
          editBusinessAdmin: (function (updatedAdmin) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.editBusinessAdmin(updatedAdmin)));
            }),
          emailIsAvailable: (function (email) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_CurrentUser.EmailAvailable.query, email);
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          fetchSavedBusinessAdmins: Curry._2(Relude_IO.mapError, (function (prim) {
                  
                }), Curry._1(dispatch, WebStore_Types_Action.fetchSavedBusinessAdmins)),
          phoneNumberIsAvailable: (function (phoneNumber) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_CurrentUser.PhoneNumberAvailable.query, phoneNumber);
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          removeBusinessAdmin: (function (id) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._1(dispatch, WebStore_Types_Action.removeBusinessAdmin(id)));
            })
        };
}

function WebContainers_BusinessDashboard_Settings_Admins(Props) {
  var setSettingsPageView = Props.setSettingsPageView;
  var subPage = Props.subPage;
  var user = Props.user;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_BusinessDashboard_Settings_Admins$Presentation, {
                              addBusinessAdmin: param$1.addBusinessAdmin,
                              editBusinessAdmin: param$1.editBusinessAdmin,
                              emailIsAvailable: param$1.emailIsAvailable,
                              fetchSavedBusinessAdmins: param$1.fetchSavedBusinessAdmins,
                              layout: param.layout,
                              phoneNumberIsAvailable: param$1.phoneNumberIsAvailable,
                              removeBusinessAdmin: param$1.removeBusinessAdmin,
                              savedBusinessAdmins: param.savedBusinessAdmins,
                              setSettingsPageView: setSettingsPageView,
                              subPage: subPage,
                              user: user
                            });
                })
            });
}

var make = WebContainers_BusinessDashboard_Settings_Admins;

exports.AddEditAdmin = AddEditAdmin;
exports.EditView = EditView;
exports.RemoveAdminModal = RemoveAdminModal;
exports.AdminList = AdminList;
exports.ListView = ListView;
exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* getNewAdminEmailIsAvailable Not a pure module */
